import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const AuthListener = ({ setIsLoggedIn }) => {
    const navigate = useNavigate();
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.type !== 'AUTH_TOKEN') {
                return;
            }
            const { token, userData, parentUrl } = event.data;
            if (token) {
                localStorage.setItem('access_token', token);
                localStorage.setItem('parentUrl', parentUrl);
                if (userData) {
                    localStorage.setItem('userData', JSON.stringify(userData));
                }
                setIsLoggedIn(token);
                const isInIframe = window.self !== window.top;
                if (isInIframe) {
                    navigate('/app');
                } else {
                    window.location.href = '/app';
                }
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [navigate, setIsLoggedIn]);
    return null;
};
export default AuthListener;